module.exports = __webpack_public_path__ + "img/normal.4bf1e318.svg";